import { useContext, useEffect, useState } from "react";
import service from "../../../../api/services";
import { useParams } from "react-router";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import { HeaderHeading } from "../../../../Context";
import molecules from "../../../../components/molecules";
import { useToasts } from "react-toast-notifications";

const { ViewStoreStaff } = organisms;
const { ConfirmationModal } = molecules;

export interface StoreStaffListProps {
    id: string;
    store_id: string;
    user: {
        id: string;
        username: string;
        email: string;
        mobile: string;
    };
}

const Page = () => {
    const params = useParams();
    const { addToast } = useToasts();

    const { setHeader, setSidebar }: any = useContext(HeaderHeading);

    const [storeStaffList, setStoreStaffList] = useState<StoreStaffListProps[]>([]);
    const [storeStaffSearchData, setStoreStaffSearchData] = useState<StoreStaffListProps[]>([]);

    const [storeStaffId, setStoreStaffId] = useState<string>("");
    const [toggleDeleteModal, setToggleDeleteModal] = useState<boolean>(false);

    // INFO:- API calling for get the store staff list
    const getStoreStaffList = async () => {
        try {
            const response = await service.store.getStoreStaffSubAdmin(
                { staff: true },
                params?.id || ""
            );
            setStoreStaffList(response?.data?.data);
            setStoreStaffSearchData(response?.data?.data)
        } catch (error: any) {
            console.error(error);
            addToast(error?.response?.data?.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    // INFO:- handle delete staff
    const handleDeleteStaff = async () => {
        let data = {
            store_id: params?.id || "",
            staff_id: storeStaffId,
        };
        try {
            const response = await service.store.deleteStoreStaffSubAdmin(data);
            if (response?.status === 200 || response?.status === 201) {
                getStoreStaffList();
                addToast(response?.data?.message, {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            console.error(error);
            addToast(error?.response?.data?.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    // INFO:- handle search 
    const handleSearch = (value: string) => {
        if (!value) {
            setStoreStaffSearchData(storeStaffList)
        }
        let filterData: StoreStaffListProps[] = storeStaffList?.filter((item) =>
            item?.user?.username?.toLowerCase()?.includes(value.toLowerCase())
        );
        setStoreStaffSearchData(filterData)
    }
    // end

    useEffect(() => {
        getStoreStaffList();
        setHeader("Store - Store Staff");
    }, []);
    return (
        <Wrapper>
            <ViewStoreStaff
                storeStaffList={storeStaffSearchData}
                handleSearch={(value: string) => handleSearch(value?.trim())}
                handleDeleteStaff={(id: string) => {
                    setToggleDeleteModal(!toggleDeleteModal);
                    setStoreStaffId(id);
                }}
            />
            {toggleDeleteModal && (
                <ConfirmationModal
                    show={toggleDeleteModal}
                    handleConfirmItem={() => {
                        setToggleDeleteModal(!toggleDeleteModal);
                        setStoreStaffId("");
                        handleDeleteStaff();
                    }}
                    onHide={() => {
                        setToggleDeleteModal(!toggleDeleteModal);
                        setStoreStaffId("");
                    }}
                    message={"delete this staff"}
                />
            )}
        </Wrapper>
    );
};

export default Page;
